import styled, { css } from 'styled-components';

import { ASSET_PATH } from '../../../../../assetsPath';

import { GenericDiv, GenericSpan } from '../../../../common/Styles';

export const WhyWrapper = styled(GenericDiv)`
	text-align: center;
	padding: 76px 0 30px;
	background-color: #fff;
`;

export const BenefitsIcons = styled(GenericSpan)`
	width: 70px;
  height: 70px;
  background: url(${ASSET_PATH.IMAGES}seo/expense/benefits.png) no-repeat; 
  background-size: 225px 75px;
  display: inline-block;
	${(props) => {
		switch (props.icon) {
			case 'freecost':
				return css`
					background-position: -3px 0;
        `;
			case 'seamless':
				return css`
					background-position: -80px 0;
        `;
			case 'save':
				return css`
					background-position: -153px 0;
        `;

			default:
				break;
		}
	}}
`;

export const BenefitWrap = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
			text-align: center;
			width: 28%;
      ${down(breakpoints.tb)} {
        width: 100%;
				display: flex;
				text-align: left;
				flex-direction: row;
				justify-content: space-between;
				margin-bottom: 40px;
				&:last-of-type: {
					margin-bottom: 0;
				}
      }
      `
);
